import ReactDOM from 'react-dom/client';
import 'react-quill/dist/quill.snow.css';
import { App } from '@/app/ui';
import { initSentry } from '@/shared/utils/sentry';
import './index.css';

initSentry();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />,
);
